module.exports = __webpack_public_path__ + "img/pills.60d1a7c7.jpg";